import { dataShoppingCartSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShoppingCartSolid = /*#__PURE__*/createIcon(dataShoppingCartSolid)
export default IconShoppingCartSolid
